import z from "zod";

import {
  PhoneNumberMessageClass,
  ProviderName,
} from "~frontend/__generated__/graphql";
import { zodEnum } from "~frontend/util/zodHelpers";

export const ShortCodeConfigSchema = z.object({
  optInKeywords: z.string(),
  optInMessage: z.string(),
  optOutKeywords: z.string(),
  optOutMessage: z.string(),
  helpKeywords: z.string(),
  helpMessage: z.string(),
});

export const SHORT_CODE_CONFIG_KEYS = Object.keys(
  ShortCodeConfigSchema.shape
) as (keyof z.infer<typeof ShortCodeConfigSchema>)[];

export const ImportOwnedPhoneNumberFormSchema = z
  .object({
    phoneNumber: z
      .string()
      .refine(phoneNumber => phoneNumber.length > 0, "Required"),
    messageClass: zodEnum(PhoneNumberMessageClass)
      .optional()
      .refine(messageClass => !!messageClass, "Required"),
    provider: zodEnum(ProviderName)
      .optional()
      .refine(provider => !!provider, "Required"),
    twilioAccountSid: z.string().optional(),
    ownedPhoneNumberPoolId: z.string().optional(),
    isOptInNumber: z.boolean(),
    shortCodeConfig: ShortCodeConfigSchema,
    tcrCampaignId: z
      .union([
        z.string().regex(/^(C|c)(\w|\d){6}$/, "Invalid 10DLC Campaign ID"),
        z.literal(""),
      ])
      .optional(),
    state: z.string().optional(),
    allowRiskyMove: z.boolean(),
    notifyTollFreeCreated: z.boolean(),
  })
  .superRefine((data, ctx) => {
    if (data.messageClass === PhoneNumberMessageClass.ShortCode) {
      if (!data.phoneNumber.match(/^(\d{5,6}|\+1\d{10})$/)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message:
            "Must be a valid 5-digit or 6-digit short code or an E.164-formatted US phone number",
          path: ["phoneNumber"],
        });
      }
      if (!data.state) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "State is required for short code imports",
          path: ["state"],
        });
      }
    } else if (data.messageClass) {
      // TODO: can we parse different formats?
      if (!data.phoneNumber.match(/^\+1\d{10}$/)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Must be a valid E.164-formatted US phone number",
          path: ["phoneNumber"],
        });
      }
    }

    if (data.isOptInNumber) {
      for (const shortCodeConfigKey of SHORT_CODE_CONFIG_KEYS) {
        if (!data.shortCodeConfig[shortCodeConfigKey]) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Required",
            path: ["shortCodeConfig", shortCodeConfigKey],
          });
        }
      }
    }
  });
